import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuthStore } from '../store/useAuthStore';

const PrivateRoute = ({ children, requiredRole }) => {
  const location = useLocation();
  const state    = useAuthStore.getState();

  if (!useAuthStore.isAuthenticated()) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (requiredRole && state.user?.account_type !== requiredRole) {
    return <Navigate to="/expert" replace />;
  }

  return children;
};

export default PrivateRoute;
